import React, { useState, useEffect } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonLoading, IonToast, IonButton, useIonViewWillEnter } from '@ionic/react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  CircularProgress,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  IconButton,
  Tooltip,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TablePagination,
  AlertColor,
  Snackbar
} from '@mui/material';
import { Visibility, CheckCircle, Pending, Warning, Inventory } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { baseUrl, config, requestID } from '../../../common/utils';
import axios from 'axios';
import { useQuery } from 'react-query';
import { deleteRequestOrder } from '../../../api/stock-transfer/stock-transfer';
import { c } from 'framer-motion/dist/types.d-6pKw1mTI';
import { useHistory } from 'react-router';
 import MoneyIcon from '@mui/icons-material/AttachMoney'; // or use any other icon

const StatusChip = styled(Chip)(({ theme }) => ({
  fontWeight: 500,
  '&.pending': {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  '&.completed': {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  '&.partial': {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.dark,
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
}));

interface RequestItem {
  id: string;
  product_id: string;
  product_name: string;
  quantity: number;
  available: number;
  transferred?: number;
}

interface TransferRequest {
  id: string;
  requested_by: string;
  items: RequestItem[];
  status: 'pending' | 'completed' | 'partial';
  date: string;
  notes?: string;
}

const MyAccountArea: React.FC = () => {
  const [requests, setRequests] = useState<TransferRequest[]>([]);
  const [loading, setLoading] = useState(false);
    const [stewardStock, setStewardStock] = useState([]);
    const [stewardData, setStewardData] = useState([]);
    const [stockCount, setStockCount] = useState('');

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [transferDialogOpen, setTransferDialogOpen] = useState(false);
  const [currentRequest, setCurrentRequest] = useState<TransferRequest | null>(null);
  const [transferQuantities, setTransferQuantities] = useState<Record<string, number>>({});
  const [selectedStaff, setSelectedStaff] = useState("");

const [filteredStock, setFilteredStock] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);
 const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);

     const history = useHistory();
  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 1500);
  };
  // const [showToast, setShowToast] = useState(false);

  const [walletBal, setWalletBal] = useState("0");
  const [wallet, setWallet] = useState([]);
  const [bankName, setBankname] = useState("");
  const [errorLogin, setErrorLogin] = useState("");
  const [user, setUser] = useState([]);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [loaded, setLoaded] = useState(false);

  const [clipboardText, setClipboardText] = useState("");
  const [pastedText, setPastedText] = useState("");
  const [fullName, setFullName] = useState("");
  let walletBalance_x = "0";
  // const copyToClipboard = async () => {
  //   try {
  //     // alert(clipboardText);
  //     await Clipboard.write({
  //       string: clipboardText,
  //     });
  //     alert("Copied to clipboard!");
  //   } catch (e) {
  //     console.error("Error copying to clipboard", e);
  //   }
  // };

  // const pasteFromClipboard = async () => {
  //   try {
  //     const { value } = await Clipboard.read();
  //     setPastedText(value);
  //   } catch (e) {
  //     console.error("Error pasting from clipboard", e);
  //   }
  // };

  const getUserProfile = async () => {
    setStatus({ loading: true, error: false });

    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      const response = await axios.post(
        baseUrl() + "users/getProfile",
        formData,
        config
      );
      console.log(response);
      const data = response.data.data;
      console.log(data);
      setUser(data);
      setBankname(response.data.bankName);

      const fullName_x =
        data.firstName + " " + data.middleName + " " + data.lastName;
      setFullName(data.firstName + " " + data.middleName + " " + data.lastName);
      //  console.log(data.registered_bankAccountNo);

      setLoaded(true);
      sendMyPush(fullName_x);
      setStatus({ loading: false, error: false });
    } catch (error) {
      setStatus({ loading: false, error: true });
      // setError(response.data.message)
    }
  };

  // alert("hi");
  // return () => {
  //   console.log("Component unmounted");
  // };

  //nameEnquiryExt($bankCode,$accountNumber)

 

  //wallets/getWalletBalance
  const sendMyPush = (fullName_x) => {
    //setlockClick(true);

    setStatus({ loading: true, error: false });
    //hideAddFaqsForm();
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("title", "My Wallet Balance");
    formData.append(
      "body",
      "Hi " +
        fullName_x +
        ", your account has been activated thanks for registering"
    );
    // formData.append("requestID", requestID());
    // formData.append("bankCode", bankCode);

    axios
      .post(baseUrl() + "pushnotifications/sendMyPush_kill", formData, config)
      .then((response) => {
        console.log(response);
        //console.log(response.data.data.accountName);
        //  setSecurityQuestionList(response.data.squestion);

        if (response.data.status == true) {
          //  setLoadedx(false);
          /*    setLoadedxx(false);
          setErrorLogin(response.data.message); */
          setStatus({ loading: false, error: true });

          // callToast();
          //  history.push("/login");
        }

        // setWallet(response.data.getWalletInfo);

        setStatus({ loading: false, error: true });

        //  callToast();
        // setStatus({ loading: false, error: true });
      })
      .catch((error) => {
        //  setStatus({ loading: false, error: true });
        throw new error("hey ");
        setStatus({ loading: false, error: true });
      });
  };
  const sendMyPush2 = (fullName_x, wallet_bal) => {
    //setlockClick(true);

    setStatus({ loading: true, error: false });
    //hideAddFaqsForm();
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("title", "My Wallet Balance");
    formData.append(
      "body",
      "Hi " +
        fullName_x +
        ", your account balance is " +
        wallet_bal +
        ", thanks for registering"
    );
    // formData.append("requestID", requestID());
    // formData.append("bankCode", bankCode);

    axios
      .post(baseUrl() + "pushnotifications/sendMyPush", formData, config)
      .then((response) => {
        console.log(response);
        //console.log(response.data.data.accountName);
        //  setSecurityQuestionList(response.data.squestion);

        if (response.data.status == true) {
          //  setLoadedx(false);
          /*    setLoadedxx(false);
          setErrorLogin(response.data.message); */
          setStatus({ loading: false, error: true });

          // callToast();
          //  history.push("/login");
        }

        // setWallet(response.data.getWalletInfo);

        setStatus({ loading: false, error: true });

        //  callToast();
        // setStatus({ loading: false, error: true });
      })
      .catch((error) => {
        //  setStatus({ loading: false, error: true });
        throw new error("hey ");
        setStatus({ loading: false, error: true });
      });
  };
  useIonViewWillEnter(() => {
   // getUserProfile();
    getWalletInfo();
getMyDigitalProducts();
    return () => {};
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getWalletInfo();
    }, 3000);
  
    return () => clearInterval(interval);
  }, []);

const [hideWallet , setHideWallet] = useState(false);

  const getWalletInfo = () => {
    // setStatus({ loading: true, error: false });
    //hideAddFaqsForm();
    const formData = new FormData();
    formData.append("requestID", requestID());

    axios
      .post(baseUrl() + "wallets/getWalletBalance", formData, config)
      .then((response) => {
       console.log(response);

        setWallet(response.data.getWalletInfo);
        setWalletBal(response.data.walletBalance);
        walletBalance_x = response.data.walletBalance;
        setLoaded(true);
        setClipboardText(
          response.data.getWalletInfo.walletName +
            "\n" +
            response.data.getWalletInfo.bankName +
            "\n" +
            response.data.getWalletInfo.accountNumber
          // " " +
          // data.middleName +
          // " " +
          // data.lastName
        );
        //  callToast();
        // setStatus({ loading: false, error: true });
      })
      .catch((error) => {
        //  setStatus({ loading: false, error: true });
        throw new error("hey ");
      });
  };

const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [purchases, setPurchases] = useState([]);

  const [products, setProducts] = useState([]);


    const getProducts = async () => {
      setStatus({ loading: true, error: false });
  
      try {
        const formData = new FormData();
        formData.append("requestID", requestID());
        const response = await axios.post(
          baseUrl() + "warehouses/getAllProduct_bar",
          formData,
          config
        );
       console.log(response);
        const data = response.data.data;
        setProducts(data);
        setStatus({ loading: false, error: false });
      } catch (error) {
        setStatus({ loading: false, error: true });
        // setError(response.data.message)
      }
    };



    const getMyDigitalProducts = async () => {
      setStatus({ loading: true, error: false });
  
      try {
        const formData = new FormData();
        formData.append("requestID", requestID());
        const response = await axios.post(
          baseUrl() + "warehouses/getMyLoadedDigitalProducts",
          formData,
          config
        );
     //  console.log(response);
        const data = response.data.data;
        setDigitalPurchase(data);
        setStatus({ loading: false, error: false });
      } catch (error) {
        setStatus({ loading: false, error: true });
        // setError(response.data.message)
      }
    };

    
     useEffect(() => {
        const interval = setInterval(() => {
          getMyDigitalProducts();
        }, 3000);
      
        return () => clearInterval(interval);
      }, []);
  
    useEffect(() => {
      getProducts();
      getMyDigitalProducts()
      getWalletInfo();
      return () => {
        console.log("Component unmounted");
      };
    }, []);

const [digitalPurchase, setDigitalPurchase] = useState([]);

 
const processPurchase  = async (purchaseArray) => {
  console.log('Received Purchase:', purchaseArray);
 //setStatus({ loading: true, error: false });
  
      try {
        const formData = new FormData();
        formData.append("requestID", requestID());

   

// Append purchase array as JSON string
formData.append("purchaseArray", JSON.stringify(purchaseArray));
        const response = await axios.post(
          baseUrl() + "warehouses/buyDigitalProducts",
         formData,
          config
        );
       console.log(response);
        const data = response.data.data;
        
       setDigitalPurchase(data);
       // setStatus({ loading: false, error: false });
      } catch (error) {
     //   setStatus({ loading: false, error: true });
        // setError(response.data.message)
      }
  // You can do something like updating state here
  // setPurchases(prev => [...prev, ...purchaseArray]);
};

  const handlePurchase = () => {
    if (selectedProduct && quantity > 0) {
      const total = selectedProduct.price * quantity;


      
      setPurchases([
        ...purchases,
        {
          id: purchases.length + 1,
          product: selectedProduct.productName,
          price: selectedProduct.price,
          qty: quantity,
          total: total,
        },
      ]);

const newPurchase = [
    {product_id: selectedProduct.product_id,
       productName: selectedProduct.productName,
      unit_price: selectedProduct.price,
      quantity: quantity,
      total: total,
      'requestID': requestID()
    }
  ];
  // Call your function with the array
  processPurchase(newPurchase);

      


      setSelectedProduct(null);
      setQuantity(1);
    }
  }


   const [productCode, setProductCode] = useState('');
  //const walletBalance = 4500.00; // Example balance, dynamic from props/API
  const [message, setMessage] = useState('');
  //const [status, setStatus] = useState(null); // null | 'success' | 'error'
  const [open, setOpen] = useState(false);

const [alertType, setAlertType] = useState<AlertColor>('success');
const showMessage = (msg, type) => {
  setMessage(msg);
  setAlertType(type); // 'success' | 'error'
  setOpen(true);
};

   const handleClose = () => setOpen(false);
const handleClear = () => {
  // logic to clear consumed products
  console.log('Cleared');
};
 
  const handleLoad = async () => {
    // Add logic to handle loading digital product
    console.log('Load product:', productCode);

     setStatus({ loading: true, error: false });
  
      try {
        const formData = new FormData();
        formData.append("requestID", requestID());
        formData.append("productCode", productCode);
        const response = await axios.post(
          baseUrl() + "warehouses/loadDigitalProduct",
          formData,
          config
        );
       console.log(response);
       if (response.data.status === true || response.data.status === 1) {
    showMessage(response.data.message, 'success');
    setStatus({ loading: false, error: false });
  } else {

    showMessage(response.data.message || 'Something went wrong', 'error');
   setProductCode(''); // Clear input on error
    setStatus({ loading: false, error: true });
  }
        const data = response.data.data;
    //    setDigitalPurchase(data);
    getMyDigitalProducts();
       setProductCode(''); // Clear input on error

        setStatus({ loading: false, error: false });
      } catch (error) {
        setStatus({ loading: false, error: true });
        // setError(response.data.message)
              showMessage('Server or network error occurred', 'error');

      }
  };
// const {
//   data: stewardInventory,
//   isLoading: isLoadingInventory,
//   error: errorInventory,
//   refetch, // <- this is the function you'll call
// } = useQuery(["getStewardInventoryAll"], getStewardInventoryAll);

 
  
 
   
 
 const handleWithdraw = async () => {
  // Add logic to handle withdrawal
  console.log('Withdraw clicked');  
}
 
 
  if (loading) return <CircularProgress />;



  return(
   <IonPage className="pushDown">
   <Snackbar
  open={open}
  autoHideDuration={4000} // <== Only on Snackbar
  onClose={handleClose}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
>
  <Alert
    onClose={handleClose}
    severity={alertType} // must be one of: 'error' | 'warning' | 'info' | 'success'
    variant="filled"
    sx={{ width: '100%' }}
  >
    {message}
  </Alert>
</Snackbar>
      <IonHeader>
        <IonToolbar>
          <IonTitle>My Account Area Dashboard</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <Box p={2}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
             My Account Area
            </Typography>

            {loading ? (
              <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
              </Box>
            ) : (
              <>
               
<Paper elevation={3} sx={{ p: 2, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Load Digital Products/Service Tips

 Code
      </Typography>

    <Box display="flex" gap={2} alignItems="stretch">
  <TextField
    fullWidth
    label="Enter Product Code"
    value={productCode}
    onChange={(e) => setProductCode(e.target.value)}
    variant="outlined"
  />
  <Button
    variant="contained"
    color="primary"
    onClick={handleLoad}
    sx={{ px: 4 }} // optional: wider button
  >
    Load
  </Button>
</Box>

      {/* Row: Wallet Balance */}
  <Box
  mt={4}
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ccc',
    borderRadius: 2,
    px: 2,
    py: 1,
  }}
>
  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
    <Typography sx={{ fontSize: 20 }} variant="subtitle2" color="text.secondary">
      Wallet Balance
    </Typography>
    <Typography variant="h5" sx={{ color: 'green', fontWeight: 'bold' }}>
      ₦{walletBal?.toLocaleString()}
    </Typography>
  </Box>

  <Button
    variant="contained"
    color="success"
    size="small"
     sx={{
      textTransform: 'none',
      fontWeight: 'bold',
      borderRadius: 2,
    }}
    onClick={handleWithdraw} // replace with your actual handler
  >
   ₦  Withdraw
  </Button>
</Box>

    </Paper>
<p>

</p>
     {/* Purchase Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
          <TableRow sx={{ backgroundColor: '#f5f5f5' }}> {/* light gray (hash-like) */}
  <TableCell sx={{ fontWeight: 'bold' }}>Product / Code</TableCell>
  <TableCell sx={{ fontWeight: 'bold' }}>Qty</TableCell>
  <TableCell sx={{ fontWeight: 'bold' }}>Price</TableCell>
  <TableCell sx={{ fontWeight: 'bold' }}>Total</TableCell>
</TableRow>
          </TableHead>
          <TableBody>
            {digitalPurchase?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No digital product loaded yet.
                </TableCell>
              </TableRow>
            ) : (
              digitalPurchase?.map((item, index) => (
           <>
           
         <TableRow 
  key={index}
  sx={{     borderTop: '10px solidrgb(162, 162, 159) 167, 159)',

    backgroundColor: item.status === 'inactive' ? '#fdecea' : 'inherit', // 
    // light red
    '&:hover': {
      backgroundColor: item.status === 'inactive' ? '#fcd1ce' : 'rgba(0, 0, 0, 0.04)', // slightly darker on hover
    },
  }}
>
  <TableCell>
    {item?.name}
    <br />
    <Typography variant="body2" sx={{ color: 'green', fontWeight: 'bold' }}>
      Code: {item?.code}
    </Typography>
  </TableCell>
  <TableCell>{item?.qty}</TableCell>
  <TableCell>
    {new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 0,
    }).format(item?.price)}
  </TableCell>
  <TableCell>
  {new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
  }).format(item?.total)}
</TableCell>
</TableRow>
 
   </> 

              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
              </>
            )}
          </Paper>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default MyAccountArea;